import { RegisterPaymentAccountsApi } from "@/features/accounts/payment/scraping/services/register-accounts-api";
import { RegisterPaymentAccountsRequestModel } from "@/features/accounts/payment/scraping/services/register-accounts-model";

/// MoneyLook 口座登録処理
export class RegisterPaymentAccountsService {
  private registerPaymentAccountsApi = new RegisterPaymentAccountsApi();

  /**
   * MoneyLook 口座登録API実行
   */
  public async registerPaymentAccounts(param: RegisterPaymentAccountsRequestModel) {
    return await this.registerPaymentAccountsApi.registerPaymentAccounts(param);
  }
}